var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"small-chart"},[_c('br'),_c('BarChart',{attrs:{"chart-data":_vm.baseChartData,"options":_vm.options,"height":400}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }